/* eslint-disable no-param-reassign, @typescript-eslint/no-unused-vars */
import { createSlice, PayloadAction, Dispatch } from '@reduxjs/toolkit';
import { config } from '@/utils';

type TOffice = {
  id: string;
  name: string;
  city: string;
  address: string;
};

type TDealer = {
  id: string;
  name: string;
  offices: TOffice[];
};

type DealersSliceState = {
  dealers?: TDealer[];
  loading: boolean;
  error?: boolean;
  selectedDealer?: string;
};

const initialState: DealersSliceState = {
  loading: false,
};

const dealersSlice = createSlice({
  name: 'dealers',
  initialState,
  reducers: {
    request: state => {
      state.loading = true;
    },
    success: (state, action: PayloadAction<TDealer[]>) => {
      state.dealers = action.payload;
      state.loading = false;
    },
    error: state => {
      state.error = true;
      state.loading = false;
    },
    dealerSelected: (state, action: PayloadAction<string>) => {
      state.selectedDealer = action.payload;
    },
    resetDealerSelectedValues: state => {
      state.selectedDealer = undefined;
    },
  },
});

const getDealers = () => (dispatch: Dispatch) => {
  dispatch(dealersSlice.actions.request());

  return fetch(
    `${config.get('carstockApi')}dealers/?page=0&per_page=1000&sort=-name`
  )
    .then(res => res.json())
    .then((res: TDealer[]) => {
      dispatch(dealersSlice.actions.success(res));
    })
    .catch(e => {
      dispatch(dealersSlice.actions.error());
    });
};

const actions = {
  ...dealersSlice.actions,
  getDealers,
};

export { dealersSlice as default, actions };
